import settings from '@/settings'

const comprarCashPosto = (headers, payload) => {
  return fetch(`${settings.apetrusApi}/carteiravirtual/cashposto/`, {
    method: 'POST',
    mode: 'cors',
    cache: 'default',
    headers: headers,
    body: JSON.stringify(payload)
  })
}

export default {
  comprarCashPosto
}
